module.exports = __webpack_public_path__ + "tablesFull.png?899fd0ab5e8d3ab421f5a7b6215b4f87";